/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//
export default {
  'project-panel.generic-error.description': 'Please check your internet connection and try again.',
  'project-panel.generic-error.title': 'Something went wrong',
  'project-panel.project-icon-header.update-error-description': 'Could not update the icon for {projectName}',
  'project-panel.project-icon-header.update-error-title': 'Something went wrong.',
  'project-panel.project-panel-expand-field-button.show-less-collapsed-label': 'Show more fields',
  'project-panel.project-panel-expand-field-button.show-more-collapsed-label': 'Show less',
  'project-panel.project-panel-header.title': 'Project',
  'project-panel.project-panel-tabs.about-tab-title': 'About',
  'project-panel.project-panel-tabs.decisions-title': 'Decisions',
  'project-panel.project-panel-tabs.learnings-title': 'Learnings',
  'project-panel.project-panel-tabs.risks-title': 'Risks',
  'project-panel.project-panel-tabs.updates-tab-title': 'Updates',
  'project-panel.project-title.edit-button-label': 'Edit project title',
  'project-panel.project-title.update-error-description': 'Could not update the content for {projectName}',
  'project-panel.project-title.update-error-title': 'Something went wrong',
  'project-panel.project-title.validation-message': 'Please specify a title for your project',
};
